import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	*:focus {
		outline: none;
	}

	html {
		font-size: 15px;
	}

	html, body, #root {
		background-color:#F1F1F1
	}

	body, textarea, button {
		font-family: 'Roboto', sans-serif;
	}

	a {
		text-decoration:none;

		&.link {
			color: #333;
			text-decoration: underline;
		}
	}

	button {
		border: none;
		background: transparent;
		padding: 0;
		outline: none;
		text-transform: none;
		overflow: visible;
	}

	input::placeholder, textarea::placeholder {
		color: #aaa;
	}

	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type=number] {
		-moz-appearance: textfield;
	}

	

	button::-moz-focus-inner,
	[type="button"]::-moz-focus-inner,
	[type="reset"]::-moz-focus-inner,
	[type="submit"]::-moz-focus-inner {
		border-style: none;
		padding: 0;
	}

	[type="number"]::-webkit-inner-spin-button,
	[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none !important;
	}



	button,
	[role="button"] {
		cursor: pointer;
	}

	button::-moz-focus-inner {
		border: 0 !important;
	}

`;
